import * as React from 'react';
import { IRadioItem } from '../../../models/IRadioItem';

type RadioSwitchItemProps = {
    active: string
    radio: IRadioItem
    onChange: (item: IRadioItem) => void;
}


export function RadioSwitchItem({ onChange, radio, active }: RadioSwitchItemProps) {
    return <div className={`radio-switch-item ${active === radio.key && 'radio-switch-item_active'}`}
        onClick={() => { onChange(radio); }}>
        {radio.label}
    </div >;
}
